export const removeUndefined = <T extends object>(obj: T): T => {
  const clearObj: Partial<T> = {};

  for (const entry of Object.entries(obj)) {
    const [key, value] = entry;
    if (value === undefined) continue;

    if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
      clearObj[key as keyof T] = removeUndefined(value);
      continue;
    }

    clearObj[key as keyof T] = value;
  }

  return clearObj as T;
};
